export const user_details = (state = null, action) => {
	if (action.type == 'LOGIN_COMPLETED') {
		// console.log('hhh', action.payload)
		return action.payload
	}
	// console.log('login', state, action)
  return state;
}

export const user = (state = -1, action) => {
	if (action.type == 'USER_DETAILS_FETCHED') {
		// console.log('hhh', action.payload)
		return action.payload
	}
	// console.log('login', state, action)
  return state;
}

export const attempting_login = (state = false, action) => {
	// console.log('attempting login', state, action)

	switch (action.type) {
		case 'LOGIN_ATTEMPTED':
	  		return true;
		case 'RECEIVE_CATEGORIES':
	  		return false;
		default:
	  		return state;
	}
};

export const login_mode = (state = "login", action) => {
	// console.log('mode login', state, action)
	switch (action.type) {
		case 'REGISTER':
	  		return "register";
		case 'LOGIN':
	  		return "login";
  		case 'OPEN_LOGIN_MODAL':
	  		return "login";
  		case 'FORGOT_PASSWORD':
	  		return "forgot_password";
		default:
	  		return state;
	}	
};